import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Cart} from '@spartacus/cart/base/root';
import {Address, B2BUser} from '@spartacus/core';
import {take} from 'rxjs/operators';
import {AddressUsage} from '@app/model/order/dcp-order-entry.model';
import {B2bUnitService} from '@app/services/b2b-unit.service';
import {DcpActiveCartService} from '@app/services/dcp-active-cart.service';

@UntilDestroy()
@Component({
  selector: 'dcp-billing-information',
  templateUrl: './billing-information.component.html',
  styleUrls: ['./billing-information.component.scss']
})
export class BillingInformationComponent implements OnChanges {
  @Input() invoiceContacts: B2BUser[];
  @Input() invoiceAddresses: Address[];
  initialSelectedInvoiceContact: number = 0;
  initialSelectedInvoiceAddress: number = 0;
  readonly contactRole = AddressUsage.INVOICE_RECIPIENT;
  readonly usageType = AddressUsage.BILL_TO;

  constructor(
    private b2bUnitService: B2bUnitService,
    private dcpActiveCartService: DcpActiveCartService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.invoiceContacts?.currentValue?.length) {
      this.dcpActiveCartService.getActiveCart().pipe(take(1), untilDestroyed(this)).subscribe((cart: Cart) => {
        const cartInvoiceRecipient = cart.addresses.find((address) => address.addressUsage === 'INVOICE_RECIPIENT');
        const previouslySelectedInvoiceRecipient = this.invoiceContacts.find((invoiceContact) => invoiceContact.email === cartInvoiceRecipient?.email);
        if (previouslySelectedInvoiceRecipient) {
          this.initialSelectedInvoiceContact = this.invoiceContacts.indexOf(previouslySelectedInvoiceRecipient);
        }
      });
    }
    if (changes.invoiceAddresses?.currentValue?.length) {
      this.dcpActiveCartService.getActiveCart().pipe(take(1), untilDestroyed(this)).subscribe((cart: Cart) => {
        const cartInvoiceAddress = cart.addresses.find((address) => address.addressUsage === 'BILL_TO');
        const initialSelectedAddress = this.invoiceAddresses.find((invoiceAddress) => invoiceAddress.externalAddressNumber === cartInvoiceAddress?.externalAddressNumber);
        if (initialSelectedAddress) {
          this.initialSelectedInvoiceAddress = this.invoiceAddresses.indexOf(initialSelectedAddress);
        }
      });
    }
  }

  onAddressSelect($event: Address): void {
    this.b2bUnitService.setCheckoutBillTo($event);
  }

  onContactSelect($event: B2BUser): void {
    this.b2bUnitService.setCheckoutInvoiceRecipient($event.uid);
  }
}
